export const SCROLLBAR_OFFSET = 16;

export const SUMMARY_TAB_NAME = 'Summary';
